import { get } from "lodash/get";
import { handleError } from "helper/rest";
import { clientPublic, clientPublicV2 } from "helper/axios";

export const getProjectKos = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`summary/kickoff`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const getProjectOverview = async ({ params, token }) => {
  try {
    return await clientPublicV2
      // .post(`account/search?`, params, {
      .post(`summary/overview`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};

export const getProjectAging = async ({ params, token }) => {
  try {
    return await clientPublic
      // .post(`account/search?`, params, {
      .post(`summary/aging`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
export const getOptiontypeStatusproject = async ({ params, token }) => {
  try {
    return await clientPublic
      // .post(`account/search?`, params, {
      .get(`optiontype?kind=project`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const { response } = error;
        const Error = get(response, "data", "");
        return handleError(Error);
      });
  } catch (error) {
    console.error("error", error);
    return error;
  }
};
